"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.directive = void 0;
var event_1 = require("./event");
var directive = function (el, _a, vNode) {
    var value = _a.value;
    if (!value) {
        (0, event_1.unmonitorElement)(el);
        delete el.__monitor;
        delete el.dataset.monitor;
        delete el.__monitor_actions;
        return;
    }
    var actions = Object.keys(value);
    el.__monitor = vNode.componentInstance.$monitor;
    el.__monitor_actions = actions;
    (0, event_1.monitorElement)(el);
    el.dataset.monitor = JSON.stringify(value);
};
exports.directive = directive;
exports.directive.install = function (Vue) {
    Vue.directive('monitor', exports.directive);
};
